<!-- TEMPLATE -->
<template>
  <div id="app">
    <v-dialog v-model="dialog" max-width="80%">
      <v-card :loading="loading" class="mx-auto my-12">
        <v-carousel>
          <v-carousel-item
            v-for="(image, i) in plugin.gallery"
            :key="i"
            :src="image"
            reverse-transition="fade-transition"
            transition="fade-transition"
          ></v-carousel-item>
        </v-carousel>

        <v-card-title>{{ plugin.title }}</v-card-title>

        <v-card-text>
          <v-row align="center" class="mx-0">
            <!--
          <v-rating
            :value="4.5"
            color="amber"
            dense
            half-increments
            readonly
            size="14"
          ></v-rating>
         
  
          <div class="grey--text ml-4">4.5 (413)</div>
           -->
          </v-row>

          <div>{{ plugin.description }}</div>
        </v-card-text>

        <v-divider class="mx-4"></v-divider>

        <v-card-title>Vendor information</v-card-title>
        <v-card-text>
          <a v-bind:href="plugin.vendor" target="_blank">{{ plugin.vendor }}</a>
        </v-card-text>

        <v-divider class="mx-4"></v-divider>

        <v-card-title>Price</v-card-title>
        <v-card-text>{{ plugin.price }} euro</v-card-text>
        <v-card-text
          >This amount will be added to your bill. Check the details in the
          billing section
        </v-card-text>
        <v-divider class="mx-4"></v-divider>

        <v-card-title>Tags</v-card-title>

        <v-card-text>
          <v-chip-group
            v-for="(tag, i) in plugin.tags"
            :key="i"
            active-class="deep-purple accent-4 white--text"
          >
            <v-chip>{{ tag }}</v-chip>
          </v-chip-group>
        </v-card-text>

        <v-card-actions>
          <v-btn
            v-if="!plugin.active"
            color="green"
            text
            v-on:click="enable(plugin.id)"
          >
            Enable
          </v-btn>
          <v-btn
            v-if="plugin.active"
            color="black"
            text
            :href="'/plugin/' + plugin.id"
          >
            Settings
          </v-btn>
          <v-btn
            v-if="plugin.active"
            color="red"
            text
            v-on:click="disable(plugin.id)"
          >
            Disable
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- INIT PLUGINS -->

    <v-card class="mt-10" max-width="350" height="280" top="10">
      <v-list-item>
        <v-list-item-content>
          <v-list-item-title class="headline">{{
            plugin.title
          }}</v-list-item-title>
          <v-list-item-subtitle>by {{ plugin.author }}</v-list-item-subtitle>
        </v-list-item-content>
      </v-list-item>

      <v-img v-bind:src="plugin.logo" height="150"></v-img>

      <v-card-actions>
        <v-chip
          v-if="plugin.active"
          class="ma-2"
          color="teal"
          text-color="white"
        >
          <v-avatar left>
            <v-icon>mdi-checkbox-marked-circle</v-icon>
          </v-avatar>
          active
        </v-chip>

        <v-spacer></v-spacer>
        <div class="mr-3">{{ plugin.price }}</div>

        <template v-slot:activator="{ on, attrs }">
          <v-btn text dark v-bind="attrs" v-on="on"> </v-btn>
        </template>

        <v-btn text v-on:click="openPluginModal(plugin.id)"> Open </v-btn>
      </v-card-actions>
    </v-card>
  </div>
</template>


<!-- SCRIPT -->
<script>
import PhishingApi from "../app/phishing-api";
export default {
  name: "MarketPlaceSinglePlugin",
  data: function () {
    return {
      dialog: false,
      userInfo: this.$store.state.cognitoInfo,
      alertSuccess: false,
      alertError: false,
      alertText: "",
    };
  },
  created() {
    this.fetchData();
  },
  computed: {},
  methods: {
    fetchData() {},

    enable(id) {
      let self = this;
      PhishingApi.enablePlugin(id)
        .then((response) => {
          self.alertText = "Plugin  added succesfully ";
          self.alertError = false;
          self.alertSuccess = true;
          this.plugin.active = true;
          this.dialog = false;
        })
        .catch(function (error) {
          console.log(error);
          self.alertText = "Something went wrong. Try again ";
          self.alertSuccess = false;
          self.alertError = true;
          this.dialog = false;
        });
    },

    disable(id) {
      let self = this;
      PhishingApi.disablePlugin(id)
        .then((response) => {
          self.alertText = "Plugin removed succesfully ";
          self.alertError = false;
          self.alertSuccess = true;
          this.plugin.active = false;
          this.dialog = false;
        })
        .catch(function (error) {
          console.log(error);
          self.alertText = "Something went wrong. Try again ";
          self.alertSuccess = false;
          self.alertError = true;
          this.dialog = false;
        });
    },

    close() {
      this.dialog = false;
    },

    openPluginModal(id) {
      this.dialog = true;
    },

    getReadableDate(value) {
      return new Date(value * 1000).toLocaleString();
    },
    changeStatus(status) {
      this.email_notifications = status;
    },

    selectOption(selected) {
      this.defaultDomainIndex = this.domains.indexOf(selected);
    },
  },
  filters: {
    toReadableDate(value) {
      return new Date(value * 1000).toLocaleString();
    },
  },
  props: ["plugin"],
};
</script>

<!-- Style -->
<style>
</style>